import React, { useEffect, useState } from "react";
import {
  I2cInput,
} from "@webcomponents/i2cwebcomponents/dist/react";

const ReviewSummarySearch = ({ value = "", onSearchChange }) => {
  const [searchValue, setSearchValue] = useState(value);

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      onSearchChange(searchValue);
    }, 300);

    return () => clearTimeout(timeout);
  }, [onSearchChange, searchValue]);

  return (
    <div className="review-summary-search">
      <I2cInput
        name="review-summary-search"
        clearable
        value={searchValue}
        onI2cInput={(event) => setSearchValue(event.target.value)}
        placeholder="Search Anything..."
        size="large"

      >
      </I2cInput>
    </div>
  );
};

export default ReviewSummarySearch;
